<mat-toolbar class="sub-toolbar">Account</mat-toolbar>
<button mat-raised-button type="button" (click)="sign_out()"><mat-icon>exit_to_app</mat-icon></button>
